import React, { Fragment } from 'react'
import TextSnippetTwoToneIcon from '@mui/icons-material/TextSnippetTwoTone'
import { Button, Modal, SvgIcon } from '../../../components'
import { useModal } from '../../../utils/hooks'
import { RenderIf } from '../../../utils/fns'
import { appConfig } from '../common/constants'

const AboutModal = () => {
  const [show, onHide] = useModal(false)

  return (
    <Fragment>
      <Button variant="topNav" className="button topNav__button" onClick={onHide}>
        <TextSnippetTwoToneIcon className="material-icons-two-tone material-icons-two-tone--noinvert" />
        <span className="button__text">About</span>
      </Button>
      {RenderIf(
        show,
        <Modal
          show={show}
          onHide={onHide}
          className="-about"
          header={
            <Modal.Header closeButton>
              <div className="appBrandingGroup">
                <SvgIcon
                  src={appConfig.logoUrl}
                  svgClasses="iconic-sm appLogo ml-0 w-100"
                  alt="ACE Logo"
                />
                <div className="aboutAppHeading">
                  <div className="aboutAppAcronym">
                    <span className="aboutAppAcronym__label"></span>
                    {appConfig.appCode}
                  </div>
                  <div className="aboutAppFullName">{appConfig.appName}</div>
                </div>
              </div>
            </Modal.Header>
          }
        >
          <Fragment>
            <p className="intro">
              The Adhesive Cartridge Estimator estimates how much adhesive you need on your next
              project whether it’s for adhesive anchors for a threaded rod or rebar doweling
              project; or for determining the ports, paste and injection materials needed for a
              crack repair.
            </p>

            <h4>
              <span className="release-number">{appConfig.appVersion}</span>
              <span className="release-date">Released on January 09, 2025</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/gear.svg" alt="Change Icon" />
                  Change
                </div>
                <div className="release-info">Maintenance</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.10.0</span>
              <span className="release-date">Released on November 14, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/gear.svg" alt="Change Icon" />
                  Change
                </div>
                <div className="release-info">Maintenance</div>
              </li>
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.9.0</span>
              <span className="release-date">Released on August 08, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.8.0</span>
              <span className="release-date">Released on July 11, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.7.0</span>
              <span className="release-date">Released on May 16, 2024</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.6.0</span>
              <span className="release-date">Released on December 14, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" svgClasses="iconic-sm" />
                  Addition
                </div>
                <div className="release-info">Added CI-PO Crack Injection Paste Over</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.5.0</span>
              <span className="release-date">Released on November 09, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" alt="Bug Fix Icon" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.4.0</span>
              <span className="release-date">Released on September 28, 2023</span>
            </h4>
            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" svgClasses="iconic-sm" />
                  Addition
                </div>
                <div className="release-info">Added ET-3G™ Epoxy Adhesive</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.3.0</span>
              <span className="release-date">Released on July 13, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" />
                  Addition
                </div>
                <div className="release-info">
                  Added AT-3G™ High-Strength Hybrid Acrylic Adhesive
                </div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.2.0</span>
              <span className="release-date">Released on April 6, 2023</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" />
                  Addition
                </div>
                <div className="release-info">Added 3GWSP Plastic Screen Tube for SET-3G</div>
              </li>
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.1.1</span>
              <span className="release-date">Released on October 25, 2021</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.1.0</span>
              <span className="release-date">Released on October 14, 2021</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" />
                  Addition
                </div>
                <div className="release-info">Added SET3G56, 56 oz cartridge size</div>
              </li>

              <li>
                <div className="release-type release-addition">
                  <SvgIcon src="assets/images/iconic/fork.svg" />
                  Addition
                </div>
                <div className="release-info">
                  Added 1/64&quot; Crack Size for the Crack-Pac product
                </div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Related Products for Crack Injection</div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Built in tutorial</div>
              </li>

              <li>
                <div className="release-type release-change">
                  <SvgIcon src="assets/images/iconic/pencil.svg" />
                  Change
                </div>
                <div className="release-info">
                  Updated footnotes and placement for Crack Injection
                </div>
              </li>

              <li>
                <div className="release-type release-change">
                  <SvgIcon src="assets/images/iconic/pencil.svg" />
                  Change
                </div>
                <div className="release-info">
                  Changed 7/16&quot; Drill Bit size to 1/2&quot; for SET-XP with 3/8&quot; Threaded
                  Rod
                </div>
              </li>

              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" />
                  Bug Fix
                </div>
                <div className="release-info">Fixed print issues</div>
              </li>

              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">3.0.0</span>
              <span className="release-date">Released on September 24, 2020</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Support for Metric Rebar</div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Water Filled Holes option for SET-3G</div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Ability to select Overage Factor</div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Additional Drill Bit Diameters</div>
              </li>

              <li>
                <div className="release-type release-newFeature">
                  <SvgIcon src="assets/images/iconic/star-empty.svg" />
                  New Feature
                </div>
                <div className="release-info">Crack Injection Estimator</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">2.0.0</span>
              <span className="release-date">Released on May 11, 2017</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-change">
                  <SvgIcon src="assets/images/iconic/pencil.svg" />
                  Change
                </div>
                <div className="release-info">Updated available adhesives</div>
              </li>

              <li>
                <div className="release-type release-bugFix">
                  <SvgIcon src="assets/images/iconic/bug.svg" />
                  Bug Fix
                </div>
                <div className="release-info">Minor bug fixes</div>
              </li>
            </ul>

            <h4>
              <span className="release-number">1.0.0</span>
              <span className="release-date">Released on August 11, 2015</span>
            </h4>

            <ul className="release-note">
              <li>
                <div className="release-type release-initial">
                  <SvgIcon src="assets/images/iconic/magic-wand.svg" />
                  Initial
                </div>
                <div className="release-info">Initial release of the application</div>
              </li>
            </ul>
          </Fragment>
        </Modal>,
      )}
    </Fragment>
  )
}

export default AboutModal
